import React, { useState, useEffect } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../../../components/ui/Card';
import { Button } from '../../../components/ui/Button';
import { Input } from '../../../components/ui/Input';
import { Alert, AlertDescription } from '../../../components/ui/Alert';
import {
  User,
  Lock,
  LogIn,
  AlertCircle,
  CheckCircle
} from 'lucide-react';

const ReferenceCustomerLogin = () => {
  // Open reference customer login URL in new window when component mounts
  useEffect(() => {
   // const referenceUrl = 'https://qa-mmuchhattisgarh.dhanushhealthcare.com/login?phone_number=9010926642&SIPexten=87678435&pass=vmedproqa&call_id=89765435678&email=saketh@dipl.com';
   const referenceUrl = 'https://bedev.samvaadpro.com/';
  
    window.open(referenceUrl, '_blank', 'noopener,noreferrer');
  }, []);
  const [formData, setFormData] = useState({
    username: '',
    password: ''
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    // Clear errors when user starts typing
    if (error) setError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess(false);
    setLoading(true);

    try {
      // TODO: Implement actual login logic here
      // This is a placeholder for the reference customer login functionality
      
      // Simulate API call
      await new Promise(resolve => setTimeout(resolve, 1000));
      
      // For now, just show success message
      setSuccess(true);
      setFormData({ username: '', password: '' });
    } catch (err) {
      setError(err.message || 'Login failed. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-6 space-y-6">
      {/* Header */}
      <div>
        <h1 className="text-2xl font-bold text-gray-900 dark:text-gray-100">
          Reference Customer Login
        </h1>
        <p className="text-sm text-gray-600 dark:text-gray-400 mt-1">
          Access customer portal for reference and support purposes
        </p>
      </div>

      {/* Main Content */}
      <div className="max-w-2xl">
        <Card>
          <CardHeader>
            <CardTitle className="flex items-center gap-2">
              <LogIn className="h-5 w-5" />
              Customer Login
            </CardTitle>
          </CardHeader>
          <CardContent>
            <form onSubmit={handleSubmit} className="space-y-4">
              {/* Error Alert */}
              {error && (
                <Alert variant="destructive">
                  <AlertCircle className="h-4 w-4" />
                  <AlertDescription>{error}</AlertDescription>
                </Alert>
              )}

              {/* Success Alert */}
              {success && (
                <Alert className="bg-green-50 dark:bg-green-900 border-green-200 dark:border-green-800">
                  <CheckCircle className="h-4 w-4 text-green-600 dark:text-green-400" />
                  <AlertDescription className="text-green-800 dark:text-green-200">
                    Login successful! Redirecting...
                  </AlertDescription>
                </Alert>
              )}

              {/* Username Field */}
              <div>
                <label htmlFor="username" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                  <User className="inline h-4 w-4 mr-1" />
                  Username
                </label>
                <Input
                  id="username"
                  name="username"
                  type="text"
                  value={formData.username}
                  onChange={handleInputChange}
                  placeholder="Enter customer username"
                  required
                  className="w-full"
                />
              </div>

              {/* Password Field */}
              <div>
                <label htmlFor="password" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                  <Lock className="inline h-4 w-4 mr-1" />
                  Password
                </label>
                <Input
                  id="password"
                  name="password"
                  type="password"
                  value={formData.password}
                  onChange={handleInputChange}
                  placeholder="Enter customer password"
                  required
                  className="w-full"
                />
              </div>

              {/* Submit Button */}
              <div className="flex items-center justify-end gap-3 pt-4">
                <Button
                  type="button"
                  variant="outline"
                  onClick={() => {
                    setFormData({ username: '', password: '' });
                    setError('');
                    setSuccess(false);
                  }}
                  disabled={loading}
                >
                  Clear
                </Button>
                <Button
                  type="submit"
                  disabled={loading || !formData.username || !formData.password}
                  className="min-w-[120px]"
                >
                  {loading ? (
                    <>
                      <span className="animate-spin mr-2">⏳</span>
                      Logging in...
                    </>
                  ) : (
                    <>
                      <LogIn className="h-4 w-4 mr-2" />
                      Login
                    </>
                  )}
                </Button>
              </div>
            </form>
          </CardContent>
        </Card>

        {/* Additional Information */}
        <Card className="mt-6">
          <CardHeader>
            <CardTitle className="text-lg">About Reference Customer Login</CardTitle>
          </CardHeader>
          <CardContent>
            <p className="text-sm text-gray-600 dark:text-gray-400">
              This module allows agents to access customer accounts for reference purposes, 
              troubleshooting, and providing support. Use this feature responsibly and only 
              when necessary to assist customers.
            </p>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default ReferenceCustomerLogin;

